<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Start time tracking</h4>
</div>
<div class="modal-body">
  <form class="form-horizontal" [formGroup]="form">
    <div class="form-group">
      <div class="row">
        <div class="col-sm-12" hidden>
          <input
            type="radio"
            name="type"
            formControlName="type"
            value="client_work"
          />
          <label for="client_work">Client Work</label>
          <input
            type="radio"
            name="type"
            formControlName="type"
            value="company_work"
          />
          <label for="company_work">Company Work</label>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <div class="col-6 col-sm-6 text-left">
              <label for="client" class="formControl">Client</label>
              <div style="font-weight: 400">{{ clientCompany.name }}</div>
            </div>
            <div class="col-6 col-sm-6 text-left">
              <label for="client" class="formControl">Job</label>
              <div style="font-weight: 400">{{ job.name }}</div>
            </div>

            <!-- <div class="col-sm-6">
                    <label for="is_billable" class="formControl">Billing</label>
                    <div>
                      <input
                        type="checkbox"
                        name="is_billable"
                        formControlName="is_billable"
                        id=""
                      />
                      Is billable?
                    </div>
                  </div> -->
          </div>
        </div>

        <div class="col-sm-12">
          <label for="notes" class="formControl" style="margin-top: 16px"
            >Notes</label
          >
        </div>
        <div class="col-sm-12">
          <textarea
            type="text"
            class="form-control"
            style="min-height: 94px; margin-top: 6px"
            formControlName="notes"
            placeholder="Notes"
          ></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-sm-6 text-left">
      <button type="button" class="btn btn-default" (click)="cancel()">
        Cancel
      </button>
    </div>
    <div class="col-sm-6">
      <button type="button" class="btn btn-primary" (click)="confirm()">
        Start tracking
      </button>
    </div>
  </div>
</div>
